import { Col, Input } from 'antd';

import { IEmailField } from './IEmailField';

import { sizes } from "../../../Assets/Enums";

const EmailField = ({
	value,
	fieldName,
	translations,
	errors,
	index = 0,
	size = "m",
	handleChangeData,
	disabled = false,
}: IEmailField) => (
	<Col xs={12} md={sizes[size]} lg={sizes[size]} >
		{(() => {
			const label = translations[fieldName] || translations.email;

			return (
				<>
		<label className="required">
			{label}
		</label>
		<Input
			className="input-field"
			name={fieldName}
			value={value}
			onChange={handleChangeData(index)}
			disabled={disabled}
			placeholder={label}
			status={errors[index][fieldName] || errors[index].invalidEmailFormat ? "error": ""}
		/>
		<span className={`error ${errors[index][fieldName] ? 'show' : null}`}>
			{translations.completeCampo}
		</span>
		<span className={`error ${errors[index].invalidEmailFormat ? "show" : null}`}>
			{translations.completeEmailValido}
		</span>
				</>
			);
		})()}
	</Col>
);

export default EmailField;
